/**
 * Page title
 */
angular.module('elogbooksDirectives').directive('pageTitle', ['$http', 'apiClient', '$state', function ($http, apiClient, $state) {
    return {
        restrict: 'AE',
        replace: true,
        transclude: true,
        templateUrl: '/modules/directives/layout/page-title/page-title.html'
    };
}]);
